import React from "react";
import RefBTech from "./RefBTech";
import RefHS from "./RefHS";
import RefeS from "./RefeS";

const References = () => {
  return (
    <div>
      <RefBTech />
      <RefHS />
      <RefeS />
    </div>
  );
};

export default References;
